<script setup lang="ts">
import LeIconButton from "@dsk/components/IconButton/LeIconButton.vue";
import LeLanguageSelectorActiveIcon from "@dsk/icons/LeLanguageSelectorActiveIcon.vue";
import LeLanguageSelectorIcon from "@dsk/icons/LeLanguageSelectorIcon.vue";
import { type Component, computed } from "vue";

import type { SearchFilter } from "@/types";

const props = defineProps<{
  filter: SearchFilter;
}>();

const filterIsActive = computed<boolean>(() => Boolean(props.filter.sourceLanguage));

const globeIconComponent = computed<Component>(() => {
  if (filterIsActive.value) {
    return LeLanguageSelectorActiveIcon;
  }

  return LeLanguageSelectorIcon;
});
</script>

<template>
  <LeIconButton size="xl" class="le-language-selector-button" role="button">
    <Component :is="globeIconComponent" class="le-language-selector-button__icon" role="presentation" />
  </LeIconButton>
</template>

<style lang="less" scoped>
@import "@dsk/styles/all";

.le-language-selector-button {
  display: flex;
  justify-content: center;
  transition: all 75ms ease-out;

  &__icon {
    width: 22px;
    height: 22px;
  }
}
</style>
